import { el } from '../../utils/dom';

/** 출처·데이터 한계 안내 */
export function createSourceNotice(variant: 'neutral' | 'success' | 'warn' | 'danger', title: string, body: string): HTMLElement {
  const panelClass =
    variant === 'success'
      ? 'ev123-panel ev123-panel--success'
      : variant === 'warn'
        ? 'ev123-panel ev123-panel--warn'
        : variant === 'danger'
          ? 'ev123-panel ev123-panel--danger'
          : 'ev123-panel';

  const wrap = el('div', { className: panelClass });
  const p = el('p', { className: 'ev123-card__desc', text: body });
  p.style.margin = '0';
  wrap.append(el('div', { className: 'ev123-panel__title', text: title }), p);
  return wrap;
}
